const VideosTropical = [
  {
    video_id: "6BV37Dcxj9s",
    title: "One Day (Vandaag)",
    artist: "Bakermat",
  },
  {
    video_id: "YZdGD-Vswz8",
    title: "Californication (GAMPER & DADONI Remix)",
    artist: "RHCP",
  },
  {
    video_id: "TJANHGsQr50",
    title: "Monte's Groove",
    artist: "Honeydripper",
  },
  {
    video_id: "IWGdMB-ja2w",
    title: "Get Lucky (Pretty Pink Edit & Daughter cover)",
    artist: "Daft Punk",
  },
  {
    video_id: "Q_2lEWvMzzc",
    title: "Oxas",
    artist: "GAMPER & DADONI, De Hofnar",
  },
  {
    video_id: "b6vSf0cA9qY",
    title: "Jubel",
    artist: "Klingande",
  },
  {
    video_id: "sqYEvGr372M",
    title: "Rivers",
    artist: "Thomas Jack",
  },
  {
    video_id: "FHCYHldJi_g",
    title: "I Got U",
    artist: "Duke Dumont ft. Jax Jones",
  },
  {
    video_id: "dRB-8gih51Q",
    title: "The Final Speech",
    artist: "Thomas Jack",
  },
];

export default VideosTropical;
